import { createAction } from 'redux-actions';
import { timeMonth } from 'd3-time';

import { updateAllData } from './data';
import { viewUpdatedAction } from './view';

const simplePayloadCreator = p => p;

export const setViewDatesAction = createAction('SET_VIEW_DATES', simplePayloadCreator);

export const setViewDates = ({
  modifier,
  selectedDates,
  selectBy,
  user,
}) => (dispatch = ignoreDispatch) => {
  dispatch(setViewDatesAction({
    modifier,
    selectedDates,
    selectBy,
    user,
  }));
  return fetchData({ dispatch, selectedDates, user })
    .then(() => {
      dispatch(viewUpdatedAction({ selectBy, selectedDates, user }));
    });
};

function ignoreDispatch(f) {
  return f;
}

export function fetchData({ dispatch = ignoreDispatch, selectedDates, user }) {
  // fetch data based on months (easier cache checking)
  // if user is not set, don't fetch (assume data is already fetched)
  if (!selectedDates.length || !user) {
    return Promise.resolve({});
  }
  // assume selectedDates are sorted...
  const months = timeMonth.range(
    timeMonth(new Date(selectedDates[0])),
    new Date(selectedDates[selectedDates.length - 1]),
  );
  const promises = [];
  months.forEach((month) => {
    const params = {
      startTime: month,
      endTime: timeMonth.offset(month, 1),
    };
    promises.push(dispatch(updateAllData({ params, user })));
  });
  return Promise.all(promises);
}
